import { render, staticRenderFns } from "./form-strategic.vue?vue&type=template&id=312cc401&"
import script from "./form-strategic.vue?vue&type=script&lang=js&"
export * from "./form-strategic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports